<app-layout>
    <admin-reports-tab :referrer="filters.referrer" section="allwallets"></admin-reports-tab>
    <h1 class="mt-10 mb-8 font-bold text-3xl">
        <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('admin.users.edit', filters.referrer)" v-if="filters.referrer">Go Back - </inertia-link> All Wallets Sum
    </h1>
   

        <div>
    <!-- Your other content here -->

<div class="bg-white rounded shadow overflow-x-auto">

         

<div class="currency-list" v-if="currencies.length > 0">
  <div class="currency-box shadow" v-for="currency in currencies" :key="currency">
        
    <div class="currency-symbol">{{ currency }}</div>
    <div class="currency-total">{{ calculateSumByCurrency(currency).toLocaleString() }}</div>
    
    
    </div>
</div>
<div class="no-currencies" v-else>
  No currencies available.
</div>	

</div>	       
</app-layout>
